import { getAuthHeaders } from '../../utils/token';
import { api } from '../Users/user';

const BASE_URL = api + '/api/organizations';

/** Interfaz para la Organización devuelta por la API */
export interface OrganizationAPI {
  _id: string;
  name: string;
  short_name: string;
  oid: string;
  country_code: string;
  structure_id: string;
  suffix: string;
  status: boolean; // true para activo, false para inactivo
  base64_logo?: string;
  createdAt: string;
  updatedAt: string;
}

/** Interfaz para los datos necesarios para crear/actualizar una organización */
export interface OrganizationData {
  name: string;
  short_name: string;
  oid: string;
  country_code: string;
  structure_id: string;
  suffix: string;
  status: boolean;
  base64_logo?: string;
}

// --- Función de Utilidad para Fetch con Manejo de Errores (Reutilizada) ---
async function apiFetch<T>(url: string, options: RequestInit): Promise<T> {
  const defaultHeaders = getAuthHeaders();
  options.headers = {
    ...defaultHeaders,
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const response = await fetch(url, options);

  const data = await response
    .json()
    .catch(() => ({ message: response.statusText || 'Error desconocido' }));

  if (!response.ok) {
    throw new Error(data.message || `La petición falló con status ${response.status}`);
  }

  return data as T;
}

/**
 * Obtiene la lista de todas las organizaciones.
 */
export function fetchAllOrganizations(): Promise<OrganizationAPI[]> {
  return apiFetch<OrganizationAPI[]>(BASE_URL, {
    method: 'GET',
  });
}

/**
 * Crea una nueva organización.
 */
export function createOrganization(organizationData: OrganizationData): Promise<OrganizationAPI> {
  return apiFetch<OrganizationAPI>(BASE_URL, {
    method: 'POST',
    body: JSON.stringify(organizationData),
  });
}

/**
 * Actualiza parcialmente una organización existente.
 */
export function updateOrganization(
  id: string,
  organizationData: Partial<OrganizationData>
): Promise<OrganizationAPI> {
  return apiFetch<OrganizationAPI>(`${BASE_URL}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(organizationData),
  });
}

/**
 * Elimina una organización por su ID.
 */
export function deleteOrganization(id: string): Promise<void> {
  return apiFetch<void>(`${BASE_URL}/${id}`, {
    method: 'DELETE',
  });
}
